import Home from './Home'
import ErrPage from './ErrPage'
import Hello from './HelloWorld'
import {UserInfo, User, MemberRights, UpdateUserInfo, UpdatePhone} from './user'
import {CommitDoc,CommitDocDetail, CommitDocDetailEdit, DocModule, ModuleDetail, SubDoc, ServiceOrder, Lawsuit, LawyerLetter, LawyerLetterDetail, LawyerLetterDetailEdit, MeetConsult, DraftDoc} from './doc'
import {OrderList, TelDetail, DocDetail, OrderEvaluate, LetterDetail, LawsuitDetail, FaceDetail, DraftDetail} from './order'
import * as cards from './card'
import {SubTel, PhoneWaiting, Payment, UnLinkReason, UnLinkResearch, LawyerWaiting, PayWaiting, PaySuccess, LawyerEvaluation} from './telephone'
import {ServiceMall} from './servicemall'
import {Video, VideoOrder, CheckLawyer} from './video'
// import {Information, Message, PostersHaibao, PostersThr } from './information'
import { VideoList, VideoDetail, VideoShowOrCancel } from './videomeeting'
import {Lawyer, LawyerInfo, LecturerInfo, CaseDetail, CheckTime, PrivateLawyer, PrivateInfo, Institute, InstituteInfo, LawAndPrivate, LawyerForInfo, Institute4Info, LawWithPrivate, LawAndPrivateYj, LawAndPrivatePa, LawyerPaInfo} from './lawyer'
import {Information, Message, PostersHaibao, PostersThr, PostersRedict } from './information'

const routers = {
  Home,
  Hello,
  UserInfo,
  User,
  VideoDetail,
  MemberRights,
  UpdateUserInfo,
  UpdatePhone,
  CommitDoc,
  DocModule,
  CommitDocDetail,
  CommitDocDetailEdit,
  OrderList,
  TelDetail,
  DocDetail,
  DraftDetail,
  ModuleDetail,
  SubDoc,
  OrderEvaluate,
  LetterDetail,
  LawsuitDetail,
  FaceDetail,
  ...cards,
  SubTel,
  Lawsuit,
  LawyerLetter,
  LawyerLetterDetail,
  LawyerLetterDetailEdit,
  MeetConsult,
  DraftDoc,
  PhoneWaiting,
  Payment,
  UnLinkReason,
  UnLinkResearch,
  ServiceOrder,
  ServiceMall,
  Lawyer,
  Information,
  LawyerWaiting,
  PayWaiting,
  PaySuccess,
  LawyerEvaluation,
  LawyerInfo,
  CaseDetail,
  CheckTime,
  PrivateLawyer,
  PrivateInfo,
  PostersHaibao,
  PostersThr,
  Message,
  VideoList,
  Video,
  VideoOrder,
  VideoShowOrCancel,
  PostersRedict,
  Institute,
  InstituteInfo,
  CheckLawyer,
  LawAndPrivate,
  LawyerForInfo,
  LecturerInfo,
  Institute4Info,
  LawWithPrivate,
  LawAndPrivateYj,
  LawAndPrivatePa,
  LawyerPaInfo,
  ErrPage
}

let modules = {}

export {
  routers,
  modules
}



// WEBPACK FOOTER //
// ./src/pages/index.js